export default (bytes, mimetype) =>
    URL.createObjectURL(new Blob([bytes], { type: mimetype }))
